import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from '../../universal-nav/hooks/useUniversalNavContext';
const formatCurrenciesData = (currenciesData) => {
    return currenciesData.map((currency) => ({
        id: currency.id,
        name: currency.name,
        icon: currency.icon,
        multiplier: currency.multiplier,
        symbol: currency.symbol,
        zeroDecimal: currency.zero_decimal,
    }));
};
export const useQueryGetCurrencies = () => {
    const { apiHostname } = useUniversalNavContext();
    const result = useQuery({
        queryKey: ['getCurrencies'],
        queryFn: async () => {
            const response = await fetch(`${apiHostname}/api/v4/currencies/rates`, {
                credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const currencyJson = await response.json();
            return currencyJson.objects;
        },
        select: formatCurrenciesData,
    });
    return result;
};
//# sourceMappingURL=useQueryGetCurrencies.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
